import React, { createContext, useContext } from "react";
import { IAuditMetaFormData } from "../interfaces/IAudit";

interface IAuditMetaContext {
    metaData: IAuditMetaFormData;
}

const defaultValue: IAuditMetaContext = {
    metaData: {},
};

const context = createContext<IAuditMetaContext>(defaultValue);
const { Provider } = context;

export const useAuditMetaContext = () => useContext(context);

// Provider
export const AuditMetaProvider: React.FC<{ metaData: IAuditMetaFormData }> = ({ children, metaData }) => {

    return (
        <Provider value={{ metaData }}>
            {children}
        </Provider>
    );
};
